import Vue from 'vue';
import store from '@/store';
import $ from 'jquery'

import ContractInfoModal from './ContractInfoModal.vue';

export default function(){
    let element = $(`<div id="gnzs-1c-amo__add-contractinfo-modal-container"></div>`)
    $('body').append(element)

    new Vue({
        store,
        render: h => h(ContractInfoModal)
    }).$mount('#gnzs-1c-amo__add-contractinfo-modal-container');
}